export const CONTENT_REACTION_TYPES = [
  "like",
  "celebrate",
  "love",
  "support",
  "insightful",
  "funny",
] as const;

export type ContentReactionType = (typeof CONTENT_REACTION_TYPES)[number];

export type ContentReactionCounts = Record<ContentReactionType, number>;

export const EMPTY_REACTION_COUNTS: ContentReactionCounts = {
  like: 0,
  celebrate: 0,
  love: 0,
  support: 0,
  insightful: 0,
  funny: 0,
};

export interface ContentReactionSummary {
  counts: ContentReactionCounts;
  current_user_reaction_type: ContentReactionType | null;
}
